import QueryRule from '~/scripts/services/model/query-rule';
import QueryWhere from '~/scripts/services/model/query-where';
import QueryWhereChild from '~/scripts/services/model/query-where-child';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';
import QueryWhereRules from '~/scripts/services/model/query-where-rules';
// eslint-disable-next-line import/no-cycle
import QueryBuilderChildrenController from '../query-builder-children/query-builder-children.controller';
// eslint-disable-next-line import/no-cycle
import QueryBuilderController from '../query-builder/query-builder.controller';
// eslint-disable-next-line import/no-cycle
import {
	operators,
	operatorsByType,
	types,
} from '../query-editor/query-editor.controller';

export const defaultDateRange = {
	duration: 1,
	unit: 'day',
};

export const fields = [
	{
		id: 'name',
		type: undefined,
	},
	{
		id: 'kid',
		type: 'string',
	},
	{
		id: 'isa',
		type: 'string',
	},
	{
		id: 'dated',
		type: 'datetime',
	},
	{
		id: 'datef',
		type: 'datetime',
	},
	{
		id: 'datecreation',
		type: 'datetime',
	},
	{
		id: 'file',
		type: 'boolean',
		values: [
			{ id: true, name: 'Présent' },
			{ id: false, name: 'Absent' },
		],
	},
	{
		id: 'ref_propri',
		type: 'string',
	},
	{
		id: 'attribut',
		type: 'string',
	},
	{
		id: 'droit',
		type: 'string',
	},
];

export default class QueryRuleController {
	#$timeout;

	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($timeout) {
		this.#$timeout = $timeout;

		/** @type {?(QueryBuilderController | QueryBuilderChildrenController)} */
		this.builder = null;

		/** @type {?QueryBuilderChildrenController} */
		this.children = null;

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		/** @type {?('attribut'|'datecreation'|'dated'|'datef'|'file'|'isa'|'kid'|'ref_propri'|'name')} */
		this.field = null;

		/** @type {any[]} */
		this.fields = fields;

		/** @type {?(QueryWhereRules|QueryWhere)} */
		this.group = null;

		/** @type {?number} */
		this.index = null;

		this.isArray = Array.isArray;

		/** @type {any} */
		this.ngModelCtrl = undefined;

		this.operators = operators;

		/** @type {any} */
		this.options = {};

		/** @type {?QueryRuleController} */
		this.parent = null;

		/** @type {?(QueryRule|QueryWhereRule|QueryWhereChild)} */
		this.rule = null;

		/** @type {boolean} */
		this.showFields = false;

		/** @type {any} */
		this.tmp = {
			node: undefined,
		};
	}

	$onInit() {
		if (!this.builder && this.children) {
			this.builder = this.children;
		}

		if (this.rule instanceof QueryWhereRule) {
			this.field = this.rule.field === 'kid' || this.rule.field === 'repre' ? 'name' : this.rule.field;
			if (this.field !== 'name') {
				this.showFields = true;
			}
		}

		if (this.builder?.options?.addRuleValueSpecificItems) {
			this.options.addRuleValueSpecificItems = this.builder.options.addRuleValueSpecificItems;
			if (this.builder.options?.ruleValueSpecificItems) {
				this.options.ruleValueSpecificItems = this.builder.options.ruleValueSpecificItems;
			}
		}

		this.ngModelCtrl.$validators.ruleRequired = () => {
			let pass = true;
			if (this.rule instanceof QueryRule && !this.rule.field && this.rule.rules?.length === 0) {
				pass = false;
			}
			return pass;
		};
	}

	changeHaving() {
		this.#$timeout(() => {
			if (this.rule instanceof QueryRule && this.rule.having && this.rule.having.operator === 'none') {
				this.rule.operator = 'none';
				this.rule.value = [];
				this.rule.linker_kid = '0';
			}
		});
	}

	isNodeRule() {
		return this.children || this.rule instanceof QueryWhereRule;
	}

	/**
	 * @param {any} rule
	 * @returns {boolean} True if rule is QueryWhere instance
	 */
	hasRules(rule) {
		return rule instanceof QueryWhere || rule instanceof QueryWhereRules;
	}

	/**
	 * @param {number} index
	 */
	removeRule(index) {
		if (this.rule instanceof QueryWhereRule) {
			if (this.parent?.rule instanceof QueryWhereRule && this.parent?.rule?.rules?.items) {
				if (Array.isArray(this.parent.rule.rules.items)) {
					this.parent.rule.rules.items.splice(index, 1);
					if (this.parent.rule.rules.items.length === 0 && this.builder instanceof QueryBuilderController) {
						// this.parent.rule.rules = null;
						this.builder.removeGroup(this.parent.index);
					}
				}
			}
			else {
				const rules = (this.group instanceof QueryWhereRules && this.group?.items)
					|| (this.group instanceof QueryWhereRule && this.group?.rules);
				if (Array.isArray(rules)) {
					rules.splice(index, 1);
					if (rules.length === 0) {
						this.group = null;
						if (this.builder instanceof QueryBuilderController) {
							if (this.builder?.rules?.length === 0) {
								this.builder.rules = [];
							}
							if (this.children?.group?.rules?.items.length === 0) {
								this.children.group.rules = null;
							}
						}
					}
				}
			}
		}
		else if ((this.group instanceof QueryWhere || this.group instanceof QueryRule) && this.rule instanceof QueryRule) {
			this.group?.rules?.splice(index, 1);
		}
	}

	/**
	 * @param {any} item
	 */
	setField(item) {
		if (this.rule instanceof QueryRule) {
			this.rule.field = item.kid;
			this.rule.linker_kid = item.linker_kid;
			this.rule.label = item.name;
			this.rule.type = item.type_kid;
			if (item.type_kid in types && types[item.type_kid] in operatorsByType) {
				this.rule.operator = operatorsByType[types[item.type_kid]][1].id;
			}
			this.ngModelCtrl.$validate();
		}
	}

	setRuleField() {
		if (this.rule instanceof QueryWhereRule && this.rule.operator) {
			if (this.field) {
				this.rule.field = this.field === 'name' ? 'repre' : this.field;
			}
			// const node = this.rule.getNode();
			// this.rule.field = this.field === 'name'
			// 	? operatorsByType[types[node?.type || 'K_NODE;STRING']].find(
			// 		(/** @type {any} */ op) => this.rule instanceof QueryWhereRule && op.id === this.rule.operator,
			// 	).fields[0]
			// 	: this.field;
			this.rule.variable = undefined;

			// automatically set rule value to true if rule.field 'file' is choosen
			if (this.rule.field === 'file' && typeof this.rule.value !== 'boolean') {
				this.#$timeout(() => {
					if (this.rule instanceof QueryWhereRule) {
						this.rule.value = true;
					}
				});
			}
		}
	}
}
